<template>
  <el-container>
    <el-container>
      <el-aside class="aside-bg" :style="{ width: asidewidth }">
        <div class="header-logo" @click="onNavsToIndex">{{ logo }}</div>
        <el-menu
          class="el-menu-vertical-demo"
          background-color="#222d32"
          text-color="#b8c7ce"
          active-text-color="#ffd04b"
          router
          :default-active="$route.path"
          unique-opened
          :collapse="isCollapse"
        >
          <el-submenu
            v-for="(item, index) in menuList"
            :key="index"
            :index="index + 1 + ''"
          >
            <template slot="title">
              <i :class="item.icon" />
              <span>{{ item.name }}</span>
            </template>
            <div class="el-nav-group-block">
              <el-menu-item-group v-for="(menu, mIndex) in item.list" :key="mIndex">
                <el-menu-item :index="menu.url" @click="returnName(menu.name)">
                  <i :class="menu.icon" />
                  <span>{{ menu.name }}</span>
                </el-menu-item>
              </el-menu-item-group>
            </div>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <div class="header-item flex">
            <div class="header-left-item">
              <i class="icons-block el-icon-s-fold" @click="changeCollapse" />
              <span
                class="welcome-info"
              >欢迎<span style="margin-left: 5px">{{ user.username }}</span></span>
            </div>

            <!-- 头部功能栏 -->
            <ul class="global-header">
              <li class="global-header-list" @click="onNavsToIndex">
                <i class="iconfont icon-home" />e互助
              </li>
              <!-- 站内信 -->
              <el-popover
                class="global-popover-block"
                placement="bottom"
                width="300"
                trigger="click"
              >
                <div class="global-message-block">
                  <p class="global-message-title">站内信</p>
                  <div class="global-message-content">
                    <ul v-if="inboxList && inboxList.length" class="list-content">
                      <li v-for="item in inboxList" :key="item.id" class="list-block">
                        <div class="title-block">
                          <p class="title" @click="onNavsToCaseDetail(item.caseCode)">
                            {{ item.msgInfo }}
                          </p>
                          <el-button
                            size="mini"
                            type="primary"
                            icon="el-icon-check"
                            circle
                            class="button-block"
                            @click="updateInboxStatus(item.id)"
                          />
                        </div>
                      </li>
                    </ul>
                    <div v-else class="global-null-block flex">
                      <i class="el-icon-folder icons" />
                      <p class="txt">暂无消息</p>
                    </div>
                  </div>
                </div>
                <!-- Popover 显示的 HTML 元素 -->
                <li slot="reference" class="global-header-list" @click="getInboxList">
                  <el-badge :is-dot="inboxNum > 0" class="badge-block">
                    <i class="icons-block el-icon-message-solid" />
                  </el-badge>
                  站内信
                </li>
              </el-popover>
              <li class="global-header-list" @click="dialogFormVisible = true">
                <i class="icons-block marginR6 el-icon-lock" />修改密码
              </li>
              <li class="global-header-list" @click="logout">
                <i class="iconfont icon-tuichu" />退出系统
              </li>
            </ul>
          </div>
        </el-header>
        <el-main>
          <h5 class="main-title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>
                <i class="iconfont icon-home" />
                <span style="margin-left: 4px">首页</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>{{ currentMenuName }}</el-breadcrumb-item>
            </el-breadcrumb>
          </h5>
          <div class="main-con">
            <router-view
              @menuchange="getMenuList"
              @setCurrentMenu="returnName"
            />
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!-- 修改密码弹出窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogFormVisible"
      width="30%"
      custom-class="c-p"
    >
      <el-form :model="form">
        <el-form-item label="账户" :label-width="formLabelWidth">
          <el-tag type="" style="font-size: 14px">{{ user.username }}</el-tag>
        </el-form-item>
        <el-form-item label="原密码" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="off" class="user-input" />
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input v-model="form.newpasswork" autocomplete="off" class="user-input" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapActions } from 'vuex'
let inBoxTimers = null // 刷新站内信-定时器

export default {
  data() {
    return {
      logo: 'e互助',
      asideTitle: '导航菜单',
      currentMenuName: '基本信息',
      menuList: [],
      user: {},
      dialogFormVisible: false,
      form: {
        name: '',
        password: '',
        newpasswork: ''
      },
      formLabelWidth: '100px',
      isCollapse: true,
      asidewidth: '65px',

      // 站内信
      inboxNum: 0, // 未读数量
      inboxList: [] // 列表数据
    }
  },

  created() {
    const vm = this
    vm.getUserInfo()
    vm.getMenuList()
    vm.getPermission()
    vm.getInboxNum(true)
  },

  destroyed() {
    clearTimeout(inBoxTimers) // 清除定时器-站内信
  },

  methods: {

    ...mapActions({
      getPermission: 'permission/getPermission'
    }),

    changeCollapse() {
      this.isCollapse = !this.isCollapse
      if (this.isCollapse) {
        this.asidewidth = '65px'
      } else {
        this.asidewidth = '230px'
      }
    },

    /**
     * 获取用户信息
     */
    async getUserInfo() {
      const vm = this

      try {
        const { data: result } = await vm.axios.get('/sys/user/info')
        if (result.status === '000000') {
          vm.user = result.user
        }
      } catch (error) {
        console.log('获取用户信息-请求失败', error)
      }
    },

    /**
     * 获取菜单列表
     */
    async getMenuList() {
      const vm = this

      try {
        const { data: result } = await vm.axios.get('/sys/menu/nav')
        vm.menuList = result.menuList
      } catch (error) {
        console.log('获取菜单列表-请求失败', error)
      }
    },

    /**
     * 获取站内信未读数量
     */
    async getInboxNum(status = false) {
      const vm = this

      try {
        const { data: result } = await vm.axios.get('/inbox/getInboxNum')
        if (result && result.status === '000000') {
          vm.inboxNum = result.num

          if (status) {
            // 每五分钟调用一次刷新
            inBoxTimers = setTimeout(() => {
              vm.getInboxNum(true)
            }, 300000)
          }
        }
      } catch (error) {
        console.log('获取站内信未读数量-请求失败', error)
      }
    },

    /**
     * 获取站内信信息
     */
    async getInboxList() {
      const vm = this

      try {
        const { data: result } = await vm.axios.get('/inbox/getInboxList')
        if (result && result.status === '000000') {
          vm.inboxList = result.result
        }
      } catch (error) {
        console.log('获取站内信信息-请求失败', error)
      }
    },

    /**
     * 站内信-消息状态更新
     * @param {number} id 站内信ID
     */
    async updateInboxStatus(id) {
      const vm = this

      if (id) {
        try {
          const { data: result } = await vm.axios.get(
            `/inbox/updateInboxTaskStatus/${id}`
          )

          if (result && result.status === '000000') {
            vm.getInboxNum(false)
            vm.getInboxList()
          }
        } catch (error) {
          console.log('站内信-消息状态更新-请求失败', error)
        }
      }
    },

    /**
     * 跳转页面-案件详情页
     * @param {string} caseCode 案件编号
     */
    onNavsToCaseDetail(caseCode) {
      if (caseCode) {
        this.$router.push({
          path: `/index/caseDetailV2/${caseCode}?from=mytask`
        })
      }
    },

    /**
     * 修改用户密码
     */
    async save() {
      const vm = this
      const data = new FormData()
      data.append('password', vm.form.password)
      data.append('newPassword', vm.form.newpasswork)

      try {
        const { data: result } = await vm.axios.post('/sys/user/password', data)
        if (result.status === '000000') {
          vm.dialogFormVisible = false
          vm.$alert('修改成功', '提示')
        }
      } catch (error) {
        console.log('修改用户密码-请求失败', error)
      }
    },

    returnName(name) {
      this.currentMenuName = name
    },

    /**
     * 退出登录
     */
    async logout() {
      const vm = this
      try {
        const { data: result } = await vm.axios.get('/logout')

        if (result && result.status === '000000') {
          window.location.replace('/login')
        }
      } catch (error) {
        console.log('退出登录-请求失败', error)
      }
    },

    /**
     * 跳转页面-首页
     */
    onNavsToIndex() {
      const { path } = this.$route

      // 避免在当前页面中重复跳转
      if (path !== '/index/info') {
        this.$router.push({
          path: '/index'
        })
        this.currentMenuName = '基本信息'
      }
    }
  }
}
</script>

<style lang="scss">
.header-logo {
  text-align: center;
  padding: 0px;
  background-color: #367fa9;
  font-size: 16px;
  font-weight: bold;
  line-height: 60px;
  height: 60px;
  color: #fff;
  cursor: pointer;
}

.header-item {
  padding: 0px;
  background-color: #3c8dbc;
  font-size: 14px;
  line-height: 60px;
  color: #fff;
  font-size: 14px;
  padding-left: 20px;

  &.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-left-item {
    display: flex;
    align-items: center;

    .icons-block {
      cursor: pointer;
      margin-right: 15px;
      font-size: 18px;
    }
  }
}

.welcome-info {
  display: inline-block;
  text-align: left;
  padding-left: 4px;
}

.item-list {
  // display: inline-block;
  display: block;
  float: right;
  text-align: right;
  margin-bottom: 0px;
}

.item-list li {
  float: right;
  line-height: 60px;
  padding: 0 15px;
  cursor: pointer;
}

/* 头部功能栏 */
.global-header {
  display: flex;
  align-items: center;
  margin-bottom: 0px;

  .global-header-list {
    height: 60px;
    line-height: 60px;
    padding: 0 15px;
    cursor: pointer;
    overflow: hidden;

    .badge-block {
      line-height: 30px;
    }

    .icons-block {
      font-size: 18px;

      &.marginR6 {
        font-size: 16px;
        margin-right: 6px;
      }
    }
  }
}

/* 站内信 */
.global-message-block {
  .global-message-title {
    line-height: 40px;
    margin: -12px 0 0 0;
    padding: 0 12px;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    border-bottom: 1px solid #ebeef5;
  }

  .global-message-content {
    max-height: 70vh;
    padding: 0 12px;
    overflow: hidden;
    overflow-y: scroll;
    margin-bottom: 0;

    // 火狐浏览器下的修改滚动条兼容
    scrollbar-color: #eee #fff;
    scrollbar-width: thin; // thin模式下滚动条两端的三角按钮会消失

    /* 修改滚动条样式 */
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #bfbfbf;
    }

    .list-content {
      margin: 0;
    }

    .list-block {
      padding: 15px 0;
      border-bottom: 1px solid #ebeef5;

      &:last-child {
        margin: 0;
        border-bottom-width: 0;
      }

      .title-block {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          flex: 1;
          color: #777;
          margin: 0 15px 0 0;
          cursor: pointer;
        }

        .button-block {
          padding: 4px;
        }
      }
    }

    /* 没有站内消息 */
    .global-null-block {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      height: 100px;
      color: #bbb;
      font-size: 14px;

      .icons {
        font-size: 30px;
        margin-bottom: 10px;
      }

      .txt {
        text-align: center;
        padding: 0;
        margin: 0;
      }
    }
  }
}

.aside-bg {
  background-color: #222d32;
}

.aside-title {
  text-align: left;
  text-indent: 25px;
  color: #8aa4af;
  font-size: 16px;
  font-weight: bold;
  line-height: 55px;
}

.el-menu {
  border-right: none;
}

.el-main {
  padding: 0px;
}

.main-intro {
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.el-menu-item-group__title {
  padding: 0px 0px 0px 20px;
}

.el-submenu .el-menu-item {
  height: 45px;
  line-height: 45px;
}

.c-p .el-dialog__header {
  background-color: #337ab7;
  color: #fff;
}

.c-p .el-dialog__title {
  color: #fff;
}

/* 修改滚动条样式 */
.el-menu--vertical .el-nav-group-block {
  max-height: 100vh;
  overflow: hidden;
  overflow-y: scroll;

  // 火狐浏览器下的修改滚动条兼容
  scrollbar-color: #bfbfbf #222d32;
  scrollbar-width: thin; // thin模式下滚动条两端的三角按钮会消失

  &::-webkit-scrollbar {
    width: 8px;
    height: 5px;
  }

  /* 修改滚动条样式 */
  &::-webkit-scrollbar-track {
    background: #222d32;
  }

  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #333;
  }
}
</style>
